module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-width-expand@l",
    attrs: {
      "id": "main-content"
    }
  }, [(_vm.page.ShopGroup.description) ? _c('div', {
    staticClass: "uk-grid-medium uk-child-width-1-1",
    attrs: {
      "uk-grid": ""
    }
  }, [_c('div', [_c('div', {
    staticClass: "uk-card uk-card-body uk-card-default"
  }, [_c('article', {
    staticClass: "uk-article uk-text-small",
    domProps: {
      "innerHTML": _vm._s(_vm.page.ShopGroup.description)
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('shop-products', {
    attrs: {
      "shop-items": _vm.page.ShopItems,
      "shop-item-prices": _vm.page.ShopItemPrices,
      "shop-items-related": _vm.page.ShopItemsRelated,
      "shop-item-properties": _vm.page.ShopItemProperties,
      "shop-item-warehouses": _vm.page.ShopItemWarehouses,
      "shop-item-tags": _vm.page.ShopItemTags,
      "shop-order-items": _vm.page.ShopOrderItems
    },
    on: {
      "load-page": _vm.loadPage,
      "buy-shop-item": _vm.buy
    }
  }, [_c('div', {
    attrs: {
      "slot": "show-settings"
    },
    slot: "show-settings"
  }, [_c('div', {
    staticClass: "uk-card uk-card-default uk-card-small uk-card-body"
  }, [_c('div', {
    staticClass: "uk-grid-small uk-child-width-1-1 tm-show-settings",
    attrs: {
      "uk-grid": ""
    }
  }, [_c('div', {
    staticClass: "uk-flex uk-flex-left"
  }, [_c('div', {
    staticClass: "uk-flex uk-flex-center uk-flex-middle tm-fast-filters"
  }, [_c('div', {
    staticClass: "tm-toggle-switch uk-flex uk-flex-middle"
  }, [_c('label', {
    staticClass: "tm-mini-switch"
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    on: {
      "change": function($event) {
        return _vm.setRequestParam('in_stock')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tm-toggle-slider",
    class: {
      'uk-active': _vm.params.in_stock === 1
    }
  })])]), _vm._v(" "), _c('div', {
    class: {
      'uk-active': _vm.params.in_stock === 1
    }
  }, [_c('span', [_vm._v("Показать только в наличии")])])])]), _vm._v(" "), _c('div', {
    staticClass: "uk-flex uk-flex-left"
  }, [_c('div', {
    staticClass: "uk-flex uk-flex-center uk-flex-middle tm-fast-filters"
  }, [_c('div', {
    staticClass: "tm-toggle-switch uk-flex uk-flex-middle"
  }, [_c('label', {
    staticClass: "tm-mini-switch"
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    on: {
      "change": function($event) {
        return _vm.setRequestParam('manufactured')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tm-toggle-slider",
    class: {
      'uk-active': _vm.params.manufactured === 1
    }
  })])]), _vm._v(" "), _c('div', {
    class: {
      'uk-active': _vm.params.manufactured === 1
    }
  }, [_c('span', [_vm._v("Скрыть снятые с производства")])])])]), _vm._v(" "), _c('div', {
    staticClass: "uk-flex uk-flex-right uk-position-absolute@s tm-items-count"
  }, [_c('div', {
    staticClass: "uk-text-meta"
  }, [_c('span', [_vm._v("товаров: " + _vm._s(_vm.page.ShopItems.total_items))])])])])])]), _vm._v(" "), _c('selected-shop-filter', {
    attrs: {
      "slot": "selected-filters",
      "filter-properties": _vm.page.ShopFilterProperties,
      "filter-property-values": _vm.page.ShopFilterPropertyValues,
      "selected-property-values": _vm.page.selectedPropertyValues
    },
    on: {
      "filter-changed": _vm.filterChanged
    },
    slot: "selected-filters"
  }), _vm._v(" "), _c('shop-filter', {
    attrs: {
      "slot": "shop-filters",
      "filter-properties": _vm.page.ShopFilterProperties,
      "filter-property-values": _vm.page.ShopFilterPropertyValues,
      "selected-property-values": _vm.page.selectedPropertyValues
    },
    on: {
      "filter-changed": _vm.filterChanged
    },
    slot: "shop-filters"
  })], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "show": _vm.loading,
      "loader-class": "tm-loader-wrapper",
      "label": ""
    }
  }, [_c('template', {
    slot: "loading-spinner"
  }, [_c('div', {
    attrs: {
      "uk-spinner": "ratio: 2"
    }
  })])], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b0897784","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/shop/ShopGroup.vue
// module id = 85
// module chunks = 0